<script setup lang="ts">
import { GetStartetdPersonalSetupProps } from '@metras/frontend-shared/interfaces'

const PersonalSetupNameFormModel = defineModel<Pick<GetStartetdPersonalSetupProps, 'surname' | 'forename' | 'academicTitle'>>()
</script>

<template>
  <div class="flex flex-col gap-5 self-start w-full">
    <CustomInput v-model="PersonalSetupNameFormModel.forename" label="Vorname*" />
    <CustomInput v-model="PersonalSetupNameFormModel.surname" label="Nachname*" />
    <CustomInput v-model="PersonalSetupNameFormModel.academicTitle" label="Akad, Titel" />
    <span class="-mt-2 pl-1 text-xs">* Pflichtfeld</span>
  </div>
</template>
